var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJewelry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#85C9FF"
    },
    points: "421.741,152.114 367.692,211.618 325.536,211.618 271.059,152.333 300.058,109.655  391.801,109.655 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00A6FF"
    },
    points: "421.741,152.114 367.692,211.618 344.2,211.618 344.2,109.655 391.801,109.655 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFCCBE"
    },
    d: "M459.853,285.783l-31.267,2.383c-3.281-42.919-39.638-76.548-82.766-76.548 c-0.543,0-1.076,0-1.62,0.021c-42.543,0.794-77.259,32.971-81.052,75.482l-31.225-2.78c2.529-28.341,15.498-54.592,36.524-73.925 c20.744-19.072,47.591-29.741,75.754-30.128c0.543-0.021,1.076-0.021,1.62-0.021c28.999,0,56.661,10.879,77.886,30.619 C444.826,230.522,457.659,257.118,459.853,285.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD9B7B"
    },
    d: "M459.853,285.783l-31.267,2.383c-3.281-42.919-39.638-76.548-82.766-76.548 c-0.543,0-1.076,0-1.62,0.021v-31.351c0.543-0.021,1.076-0.021,1.62-0.021c28.999,0,56.661,10.879,77.886,30.619 C444.826,230.522,457.659,257.118,459.853,285.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7AFF3"
    },
    d: "M512,335.798v94.899c0,32.02-25.645,58.062-57.163,58.062H233.02 c-31.518,0-57.163-26.042-57.163-58.062v-78.983l0.01-0.387l0.543-15.832c0.188-5.309,1.285-10.503,3.271-15.519h329.089 c1.097,2.811,1.912,5.664,2.445,8.58c0.01,0.042,0.021,0.084,0.021,0.125c0.105,0.502,0.188,1.003,0.261,1.515 c0.073,0.439,0.136,0.888,0.188,1.338c0.073,0.658,0.136,1.317,0.188,1.975c0.052,0.658,0.094,1.327,0.115,1.986L512,335.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#867B6E"
    },
    d: "M512,335.798v15.916H175.857l0.01-0.387l0.543-15.832c0.188-5.309,1.285-10.503,3.271-15.519 c4.661-11.809,14.191-22.677,28.069-32.04c6.793-4.577,14.62-8.81,23.44-12.603c0.679-0.293,1.359-0.585,2.048-0.857 c10.837-4.525,22.823-8.308,35.656-11.318c23.022-5.382,48.73-8.245,75.305-8.245c27.913,0,54.874,3.156,78.764,9.092 c12.331,3.051,23.837,6.845,34.245,11.328c0.491,0.209,0.982,0.428,1.463,0.637c26.021,11.495,43.233,26.742,50.046,44.006 c1.108,2.811,1.944,5.674,2.498,8.58c0.01,0.042,0.021,0.084,0.021,0.125c0.094,0.502,0.188,1.014,0.261,1.515 c0.073,0.439,0.136,0.888,0.188,1.338c0.073,0.658,0.136,1.317,0.188,1.975c0.052,0.658,0.094,1.327,0.115,1.986L512,335.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7AFF3"
    },
    d: "M207.751,23.241v328.473h-83.038c-3.637,0-7.242-0.157-10.795-0.47 C50.182,345.757,0,292.137,0,227.001v-79.046C0,82.829,50.182,29.198,113.918,23.712c3.553-0.314,7.158-0.47,10.795-0.47H207.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7885EB"
    },
    d: "M512,335.798v94.899c0,32.02-26.052,58.062-58.072,58.062H344.2V319.977h164.518 c1.986,5.016,3.093,10.21,3.271,15.519L512,335.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766957"
    },
    d: "M512,335.798v15.916H344.2v-96.801c27.913,0,54.874,3.156,78.764,9.092 c12.331,3.051,23.837,6.845,34.246,11.328c0.491,0.209,0.982,0.428,1.463,0.637c26.021,11.495,43.233,26.742,50.046,44.006 c1.986,5.016,3.093,10.21,3.271,15.519L512,335.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7885EB"
    },
    d: "M207.751,187.478v164.236h-83.038c-3.637,0-7.242-0.157-10.795-0.47 C50.182,345.757,0,292.137,0,227.001v-39.523H207.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7E9FF"
    },
    d: "M145.269,23.241v328.473h-20.556c-3.637,0-7.242-0.157-10.795-0.47V23.712 c3.553-0.314,7.158-0.47,10.795-0.47H145.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDDFF"
    },
    d: "M145.269,187.478v164.236h-20.556c-3.637,0-7.242-0.157-10.795-0.47V187.478H145.269z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJewelry);
export default __webpack_public_path__ + "static/media/jewelry.2500d036c4c1277b5a7c1ee5e575b8f5.svg";
export { ForwardRef as ReactComponent };